import React, { useEffect, useState } from 'react';
import { apiRequest } from "../services/api";
import { useLocation } from 'react-router-dom';

import { Link } from 'react-router-dom';
import NotFound from './NotFound';

const AllPackages = () => {
    const [data, setData] = useState([]);
    const location = useLocation();
    const query = new URLSearchParams(location.search).get("q");


    useEffect(() => {
        if (query && query.trim() !== "") {
            apiRequest({ url: `/search-packages?q=${encodeURIComponent(query)}` })
                .then((res) => {
                    if (res.success && Array.isArray(res.data)) {
                        setData(res.data);

                        if (res.data.length === 0) {
                            // toast.info("No packages found for your search.");
                        }
                    } else {
                        // toast.error("Something went wrong while searching.");
                    }
                })
                .catch((err) => {
                    console.error("Search error:", err.message);
                    // toast.error("Error fetching search results.");
                });
        } else {
            apiRequest({ url: "/packages-all" })
                .then((res) => {
                    if (res.success && Array.isArray(res.data)) {
                        setData(res.data);
                    } else {
                        console.warn("Unexpected response format:", res);
                    }
                })
                .catch((err) => {
                    console.error("Error loading hero slides:", err.message);
                });
        }
    }, [query, location.key]);

    // if (loading) {
    //     return <div className="text-center py-5">Loading...</div>;
    // }

    return (
        <div className="container py-5">
            <div className="mx-auto text-center mb-4" style={{ maxWidth: '700px' }}>
                <h5 className="section-title px-3">Our Packages</h5>
                <h1 className="mb-0">Explore Our Tour Options</h1>
            </div>
            {query && query.trim() !== '' && (
                <div className="py-4">
                    <span className='p-2 bg-primary text-white px-4 rounded-pill'> Search results for : <strong>{query}</strong> </span>
                </div>
            )}

            {data.length === 0 ? (
                <NotFound />
            ) : (
                <div className="row g-4">
                    {data.map(pkg => (
                        <div className="col-md-3" key={pkg.id}>
                            <div className="card overflow-hidden rounded h-100 shadow-sm">
                                <div className='packages-img position-relative'>
                                    <img src={pkg.image} className="card-img-top" alt={pkg.title} style={{ height: 200, objectFit: 'cover', width: '100%' }} />
                                    <div
                                        className="packages-info d-flex border border-start-0 border-end-0 position-absolute"
                                        style={{ width: "100%", bottom: 0, left: 0, zIndex: 5 }}
                                    >
                                        <small className="flex-fill text-center border-end py-2 package-img-tile">
                                            <i className="fas fa-globe  me-2"></i>
                                            {pkg.country}
                                        </small>
                                        {pkg.city && (
                                            <small className="flex-fill text-center py-2 package-img-tile">
                                                <i className="fa fa-map-marker-alt me-2"></i>
                                                {pkg.city}
                                            </small>
                                        )}
                                    </div>
                                </div>

                                <div className="card-body p-3">
                                    <h6 className="card-title mb-0">{pkg.title}</h6>
                                </div>
                                <div className="row bg-primary rounded-bottom mx-0">
                                    <div className="col-12 text-center px-0">
                                        <Link to={`/package-details/${pkg.id}`} className=" btn text-white py-2 px-4">
                                            View details
                                        </Link>
                                    </div>
                                </div>

                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default AllPackages;
